import React from "react";
import { ClipboardCheckIcon } from "lucide-react";
import { images } from "../../data/content";
import { OfferBlock } from "../OfferBlock";
type HeroProps = {
  firstCtaId: string;
};
export function Hero({
  firstCtaId
}: HeroProps) {
  return <header className="bg-canvas px-4 pb-14 pt-6 md:pb-20 md:pt-10" data-id="element-197" data-mp="cujk4a5lffz6">
      <div className="mx-auto max-w-5xl" data-id="element-198" data-mp="hvz2fugdz8dv">
        <div className="flex flex-wrap items-center justify-center gap-2.5" data-id="element-199" data-mp="hsl18pjgl580">
          <span className="flex items-center gap-2" data-id="element-200" data-mp="mtirlpemh5kl">
            <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-navy" data-id="element-201" data-mp="qv40z0ry71q1">
              <ClipboardCheckIcon className="h-5 w-5 text-white" aria-hidden="true" data-id="element-202" data-mp="vmm5tzx3dmga" />
            </span>
            <span className="font-serif text-lg font-extrabold text-navy" data-id="element-203" data-mp="10lyqce0hqhfp">Implant Planning Playbook™</span>
          </span>
        </div>

        <h1 className="mx-auto mt-6 max-w-4xl text-center font-serif text-[36px] font-extrabold leading-[1.08] text-navy md:text-6xl" data-id="element-204" data-mp="15m3807d4xi7i">
          Plan an Implant Case in{" "}
          <em className="italic text-brand" data-id="element-205" data-mp="9o2p5jd04mm0">20 Minutes</em>{" "}
          — Before You Enter the Surgical Room
        </h1>

        <p className="mx-auto mt-5 max-w-2xl text-center text-[17px] leading-relaxed text-ink-muted md:text-xl" data-id="element-206" data-mp="4n4ysjhu8m9f">
          A step-by-step clinical planning system to move from{" "}
          <strong className="text-ink" data-id="element-207" data-mp="3ruh2bg3g4sjc">"I'm not sure what to do with this case"</strong> to a clear, structured implant treatment plan.
          Includes <strong className="text-ink" data-id="element-208" data-mp="sgeu8dv1i1zu">6 practical volumes</strong>, <strong className="text-ink" data-id="element-209" data-mp="ng8yalhqltby">5 professional planning tools</strong> and{" "}
          <strong className="text-ink" data-id="element-210" data-mp="inpgtdfxie1v">40+ checklists & frameworks</strong>.
        </p>

        <img src={images.main} alt="Implant Planning Playbook: 6 volumes, 5 bonuses, worksheets on laptop, tablet and phone" className="mx-auto mt-6 w-full max-w-3xl md:mt-8" data-id="element-211" data-mp="enfeqbv9c7sa" />

        <p className="mt-2 text-center text-sm font-semibold text-ink-muted" data-id="element-212" data-mp="16d0nfbjyn2nx">
          Created by <span className="text-navy" data-id="element-213" data-mp="30lnmgj2brxpf">Dr. Michael Carter</span>
        </p>

        <div className="mt-8" data-id="element-214" data-mp="35l0i9tb6cf45">
          <OfferBlock label="Get the Implant Planning Playbook™" id={firstCtaId} data-id="element-215" data-mp="35jywouwj8a86" />
        </div>
      </div>
    </header>;
}